/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API } from "../../config/api";
import { FaCheckCircle, FaClock, FaRegArrowAltCircleLeft } from 'react-icons/fa'
import "bulma/css/bulma.css";
import "../../index.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
// Modal Role
import LoaderHome from "../Loader/LoaderHome"
import axios from "axios";
import moment from 'moment';

import { Badge, Button, Card, Container, ListGroup, Row, Table } from "react-bootstrap";
import PatientSatuSehat from "./AdminSatuSehat/Patient";
import EncounterSatuSehat from "./AdminSatuSehat/Encounter";
import AppointmentHistory from "./AdminSatuSehat/Appointment";
import ConditionSatuSehat from "./AdminSatuSehat/Condition";
import ObservationSatuSehat from "./AdminSatuSehat/Observation";
import ProcedureSatuSehat from "./AdminSatuSehat/Procedure";
import WellcomeCard from "../Admin/Components/Wellcome";
import HeaderPatient from "./Components/HeaderPatient";
import HeaderSatuSehat from "./AdminSatuSehat/Header";
import HompageSatuSehat from "./AdminSatuSehat/Homepage";

export default function Login() {
  document.title = "SDC Apps";
  const navigate = useNavigate()
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [ascending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");

  const token = localStorage.getItem("token");
  const [search] = useState("")
  const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  // Responsive to mobile or dekstop
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1224px)' })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  // modal role add 
  const { id } = useParams()
  const [getDataAppointmentPatient, setGetDataAppointmentPatient] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getProvince, setGetDataProvince] = useState([])
  const [getCity, setGetDataCity] = useState([])
  const [getRegency, setGetDataRegency] = useState([])
  const [getDistrict, setGetDataDistrict] = useState([])
  const [getData, setGetData] = useState([]);
  const [getIdPatientSSP, setGetDataIDPatientSSP] = useState(null);
  const [getEncounter, setGetDataEncounter] = useState(null);
  const [getCondition, setGetDataCondition] = useState(null);
  const [getObservation, setGetDataObservation] = useState(null);
  const [getProcedure, setGetDataProcedure] = useState(null);
  const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);
  const [getDataTokenSatuSehat, setGetDataTokenSatuSehat] = useState([]);


  const [getNewEncounter, setGetNewEncounter] = useState([]);
  const [getDataNewAppointmentPatient, setGetDataNewAppointmentPatient] = useState([]);
  const [getNewPatient, setGetNewPatient] = useState([]);
  const [hasError, setHasError] = useState(false);



  // console.log(getNewEncounter, "getNewEncounter")
  // getNewEncounter.forEach(item => {
  //   console.log(item.id);
  // });



  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };


  const GenerateTokenSatuSehat = async () => {
    try {
      const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/generate-token`, fetchParams);
      if (response?.status === 200) {
        setGetDataTokenSatuSehat(response.data);
      }
      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  const GetResponseDataProfile = async () => {
    try {
      const response = await API.get(`user-service/auth/profile`, fetchParams)
      // Checking process
      if (response?.status === 200) {
        setGetDataProfileDetail(response.data.data.user_detail)
      }
      return response;
    } catch (error) {
      return { status: 500 };
    }
  }


  const GetResponseDataAppointment = async () => {
    try {
      const response = await API.get(`transaction-service/appointments/ssp/appointment/${id}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}`, fetchParams);
      if (response?.status === 200) {
        if (response.data.data.length !== 0) {
          setGetDataAppointmentPatient(response.data.data);
        }
      }
      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  const GetEncounterPatient = async () => {
    try {
      const responsePatient = await API.get(`transaction-service/appointments/ssp/patient/${id}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}`, fetchParams);
      // Start
      const list = responsePatient?.data?.data || [];
      const encounterIds = list.map(item => item.id_appointment_ssp);


      const response = await Promise.all(
        encounterIds.map(idAppointmentSSP =>
          axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter-id`, {
            params: { idEncounter: idAppointmentSSP },
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json"
            }
          })
        )
      );


      const patientArray = responsePatient.data.data;
      const appointmentIds = patientArray.map(item => item.id_appointment);
      const appointmentDetails = await Promise.all(
        appointmentIds.map(id =>
          API.get(`transaction-service/appointments/${id}`, fetchParams)
        )
      );
      setGetNewPatient(responsePatient)
      setGetDataNewAppointmentPatient(appointmentDetails.map(res => res.data.data))
      // End

      const reference = response?.[0]?.data?.subject?.reference
      const kode = reference?.split("/")?.[1]
      if (response[0].data.status === "arrived") {
        setGetNewEncounter(response.map(r => r.data))
        if (kode) {
          setGetDataIDPatientSSP(kode)
        }
        setGetDataEncounter(response.data)
      }

      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  useEffect(() => {
    if (getIdPatientSSP) {
      console.log("ID Patient SSP:", getIdPatientSSP)
    }
  }, [getIdPatientSSP]);
  const GetResponseProvince = async () => {
    try {
      const responsePatient = await API.get(`transaction-service/appointments/ssp/patient/${id}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}`, fetchParams);
      const codeProvince = responsePatient.data?.patient?.province;
      const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/provinces`, fetchParams);

      const findProvince = response.data.data.data.find((item) => item.code === codeProvince);
      if (findProvince) {
        setGetDataProvince(findProvince.name);
        setGetData(responsePatient?.data?.patient)
      } else {
        setHasError(true);
        Swal.fire({
          title: "Failed",
          text: "Data belum terkirim ke satu sehat",
          timer: 3000,
          showConfirmButton: false,
          didClose: () => {
            navigate("/patients");
          },
        });
      }


      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  const GetResponseCity = async () => {
    try {
      const responsePatient = await API.get(`transaction-service/appointments/ssp/patient/${id}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}`, fetchParams);
      const codeProvince = responsePatient.data?.patient?.province;
      const codeCity = responsePatient.data?.patient?.regency;

      const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/cities', {
        params: { province_id: codeProvince },
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json"
        }
      });

      const filteredCity = response.data.data.data.find(item => item.bps_code === codeCity);
      if (filteredCity) {
        setGetDataCity(filteredCity.name);
      } else {
        setHasError(true);
        Swal.fire({
          title: "Failed",
          text: "Data belum terkirim ke satu sehat",
          timer: 3000,
          showConfirmButton: false,
          didClose: () => {
            navigate("/patients");
          },
        });
      }
      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  const GetResponseRegency = async () => {
    try {
      const responsePatient = await API.get(`transaction-service/appointments/ssp/patient/${id}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}`, fetchParams);
      const codeCity = responsePatient.data?.patient?.regency;
      const codeRegency = responsePatient.data?.patient?.district;

      const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/regencies', {
        params: { city_id: codeCity },
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json"
        }
      });

      const filteredRegency = response.data.data.data.find(item => item.code === codeRegency);
      if (filteredRegency) {
        setGetDataRegency(filteredRegency.name);
      } else {
        setHasError(true);
        Swal.fire({
          title: "Failed",
          text: "Data belum terkirim ke satu sehat",
          timer: 3000,
          showConfirmButton: false,
          didClose: () => {
            navigate("/patients");
          },
        });
      }
      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  const GetResponseDistrict = async () => {
    try {
      const responsePatient = await API.get(`transaction-service/appointments/ssp/patient/${id}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}`, fetchParams);
      const codeRegency = responsePatient.data?.patient?.district;
      const codeDistrict = responsePatient.data?.patient?.sub_district;

      const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/districts', {
        params: { regency_id: codeRegency },
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json"
        }
      });

      const filteredDistrict = response.data.data.data.find(item => item.code === codeDistrict);
      if (filteredDistrict) {
        setGetDataDistrict(filteredDistrict.name);
      } else {
        setHasError(true);
        Swal.fire({
          title: "Failed",
          text: "Data belum terkirim ke satu sehat",
          timer: 3000,
          showConfirmButton: false,
          didClose: () => {
            navigate("/patients");
          },
        });
      }
      return response;
    } catch (error) {
      return { status: 500 };
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        GenerateTokenSatuSehat(),
        GetResponseDataProfile(),
        GetResponseDataAppointment(),
        GetEncounterPatient(),
        GetResponseProvince(),
        GetResponseCity(),
        GetResponseRegency(),
        GetResponseDistrict(),
      ]);

      setLoading(false);
    } catch (error) {
      setLoading(false)
      Swal.fire({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Unknown error'}`,
        icon: 'error',
        timer: 3000,
        showConfirmButton: false
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const buttonRefresh = () => {
    window.location.reload();
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };


  const navigateHome = () => {
    navigate('/patients');
  }

  return (
    <>
      <Row>
        <WellcomeCard
          getDataProfileNull={getDataProfileDetail === null}
          getDataProfileFirstName={getDataProfileDetail?.firstname}
          getDataProfileLastName={getDataProfileDetail?.lastname}
        />
      </Row>
      {loading && <LoaderHome />}
      <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
        {isTabletOrMobile ?
          <>
            {/* header */}
            <HeaderSatuSehat
              isTabletOrMobile={isTabletOrMobile}
              query={query}
              setQuery={setQuery}
              limit={limit}
              setLimit={setLimit}
              buttonRefresh={buttonRefresh}
              searchData={searchData}
            />
            {/* end header */}
            <Col xl='12' sm='12'>
              <div>
                {/* Homepage Start */}
                <HompageSatuSehat
                  getData={getData}
                  getIdPatientSSP={getIdPatientSSP}
                  getDataAppointmentPatient={getDataAppointmentPatient}
                  getProvince={getProvince}
                  getCity={getCity}
                  getRegency={getRegency}
                  getDistrict={getDistrict}
                  getNewEncounter={getNewEncounter}
                  getDataNewAppointmentPatient={getDataNewAppointmentPatient}
                  getNewPatient={getNewPatient}
                  hasError={hasError}
                />
                {/* Homepage Start */}
              </div>
            </Col>
          </>
          :
          <>
            {/* header */}
            <HeaderSatuSehat
              isTabletOrMobile={isTabletOrMobile}
              query={query}
              setQuery={setQuery}
              limit={limit}
              setLimit={setLimit}
              buttonRefresh={buttonRefresh}
              searchData={searchData}
            />
            {/* end header */}
            <Col xl='12' sm='12'>
              <div>
                {/* Homepage Start */}
                <HompageSatuSehat
                  getData={getData}
                  getIdPatientSSP={getIdPatientSSP}
                  getDataAppointmentPatient={getDataAppointmentPatient}
                  getProvince={getProvince}
                  getCity={getCity}
                  getRegency={getRegency}
                  getDistrict={getDistrict}
                  getNewEncounter={getNewEncounter}
                  getDataNewAppointmentPatient={getDataNewAppointmentPatient}
                  getNewPatient={getNewPatient}
                  hasError={hasError}
                />
                {/* Homepage Start */}
              </div>
            </Col>
          </>
        }
      </div>
    </>
  );
}
